import React from "react";
import { useSettings } from "../../context/SettingsContext";

export const Footer = () => {
  const { settings } = useSettings();
  const brand = settings?.brand_name || "Bishal Banerjee";
  const year = new Date().getFullYear();

  return (
    <footer className="border-t px-6 md:px-10 py-12" style={{ borderColor: "var(--border-color)" }}>
      <div className="mx-auto max-w-7xl flex flex-col md:flex-row md:items-center md:justify-between gap-8">
        <div>
          <p className="font-heading text-lg font-semibold tracking-tight">
            {brand}<span style={{ color: "var(--accent-color)" }}>.</span>
          </p>
          <p className="mt-1 text-sm" style={{ color: "var(--text-secondary)" }}>Video editing studio</p>
        </div>

        <div className="flex flex-wrap items-center gap-6 text-sm" style={{ color: "var(--text-secondary)" }}>
          <a href={settings?.instagram_url || "#"} target="_blank" rel="noreferrer" className="hover:text-[var(--text-primary)] transition-colors" data-testid="footer-instagram">Instagram</a>
          <a href={settings?.twitter_url || "#"} target="_blank" rel="noreferrer" className="hover:text-[var(--text-primary)] transition-colors" data-testid="footer-twitter">X / Twitter</a>
          {settings?.youtube_url && <a href={settings.youtube_url} target="_blank" rel="noreferrer" className="hover:text-[var(--text-primary)] transition-colors" data-testid="footer-youtube">YouTube</a>}
          <a href={`mailto:${settings?.email || ""}`} className="hover:text-[var(--text-primary)] transition-colors" data-testid="footer-email">{settings?.email || "Email"}</a>
        </div>
      </div>
      <div className="mx-auto max-w-7xl mt-10 flex flex-col md:flex-row md:items-center md:justify-between gap-3 text-xs" style={{ color: "var(--text-secondary)" }}>
        <span>© {year} {brand}. All rights reserved.</span>
        <a href="/admin/login" className="hover:text-[var(--text-primary)] transition-colors" data-testid="footer-admin-link">Admin</a>
      </div>
    </footer>
  );
};
